import React from 'react';
import { DatePicker, DatePickerRefType } from '@odin-labs/components';
import { useJobsiteSchedules } from './jobsiteSchedulesProvider';

export function JobsiteScheduleDateSelector(): React.ReactElement {
  const { handleDateChange, date } = useJobsiteSchedules();

  const dateRef = React.useRef<DatePickerRefType<false>>(null);

  return (
    <DatePicker
      key={date.format('YYYY-MM-DD')}
      name="date"
      onChange={handleDateChange}
      ref={dateRef}
      showDefaultIcon
      size="sm"
      value={date}
    />
  );
}
